import { render, staticRenderFns } from "./CantPay.vue?vue&type=template&id=ca418f9a&scoped=true&"
import script from "./CantPay.vue?vue&type=script&lang=js&"
export * from "./CantPay.vue?vue&type=script&lang=js&"
import style0 from "./CantPay.vue?vue&type=style&index=0&id=ca418f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca418f9a",
  null
  
)

export default component.exports